module.exports = __webpack_public_path__ + "img/pytrace-ui.cfb0b938.png";